module.exports = __webpack_public_path__ + "img/img23.f901492a.png";